import { Injectable } from "@angular/core";
import { BehaviorSubject, from, Observable, Subject, Subscriber } from "rxjs";
import { Platform } from '@ionic/angular';
import { DeviceDetectorService } from 'ngx-device-detector';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { ToastrService } from 'ngx-toastr';
import { Contacts, Contact, ContactField, ContactName } from '@ionic-native/contacts';
import { environment } from "src/environments/environment";
import { NativeStorage } from "@ionic-native/native-storage/ngx";
import { MobileService } from "./mobile.services";
import { ObservableService } from "./observable.service";
import { CustomerInfo } from "./models/customer-info.model";
@Injectable({
    providedIn: 'root'
})

export class Data {

    //   public storage : any;
    private mapData = new Map();
    accountCardDefaultWidth: number;
    requiredGreenifyFeature:boolean = false;

    customerInfo: CustomerInfo;

    setData(key, value) {
        this.mapData.set(key, value);
    }
    getData(key) {
        return this.mapData.get(key);
    }
    removeData(key) {
        return this.mapData.delete(key);
    }

    constructor(
        public deviceService: DeviceDetectorService,
        private socialSharing: SocialSharing,
        private toastrService: ToastrService,
        private platform: Platform,
        private contacts: Contacts,
        private nativeStorage: NativeStorage,
        private mobileService: MobileService,
        private observerable:ObservableService
    ) {
        this.observerable.getMobileAppConfig().subscribe(
            () => {
                this.loadData('signature').then(
                    (res) => (res) ? this.mobileService.isPINConfigured = true : this.mobileService.isPINConfigured = false,
                    (error) => this.mobileService.isPINConfigured = false
                );
                if(this.mobileService.isFaceIDAvailable){
                    this.loadData('faceID').then(
                        (res) => (res) ? this.mobileService.isFaceIDConfigured = true : this.mobileService.isFaceIDConfigured = false,
                        (error) => this.mobileService.isFaceIDConfigured = false
                    );
                }
            }
        );
     }

    formGenericData: any;
    RefNo: any;
    draftNo: any;
    draftRemarks: any;

    private routeParams = new Map<number, Map<any, any>>();
    setRouteParams(currentLevel, routeParamsMap) {
        console.log("=> ", currentLevel, routeParamsMap);
        this.routeParams.set(currentLevel, routeParamsMap);
    }

    getRouteParam(currentLevel, key) {
        var routeParamMap = this.routeParams.get(currentLevel);
        if (routeParamMap) {
            return routeParamMap.get(key);
        }
        return undefined;
    }

    modalRefs: Map<number, any> = new Map<number, any>();
    setModalReference(currentLevel: number, modalRef) {
        this.modalRefs.set(currentLevel, modalRef);
    }

    getModalReference(level: number) {
        return this.modalRefs.get(level);
    }

    private userLoggedIn: boolean = false;

    isUserLoggedIn(): boolean {
        return this.userLoggedIn;
    }

    setUserLoggedIn(loggedIn: boolean) {
        this.userLoggedIn = loggedIn;
    }

    private _pushPayload = {};
    public getPushPayload() {
        return this._pushPayload;
    }
    public setPushPayload(value) {
        this._pushPayload = value;
    }

    checkBreadcrumbUpdate: Subject<any> = new Subject<any>();

    updateBreadcrumb(breadcrumbData: any[]) {
        this.checkBreadcrumbUpdate.next(breadcrumbData);
    }

    isMobile() {
        return this.deviceService.isMobile();
    }

    isHybrid() {
        return (window['cordova']) ? true : false;
    }

    months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    dateConversion(inputDate: any, srcFomate?: any, designateFomate?: any) {
        if (!designateFomate && !srcFomate) {
            let currentDate
            if (inputDate.includes('/')) {
                currentDate = new String(inputDate).split(' ')[0].split('/');
            } else {
                currentDate = new String(inputDate).split(' ')[0].split('-');
            }

            let day = currentDate[0].charAt(0) != '0' ? parseInt(currentDate[0]) : '0' + parseInt(currentDate[0]);
            let month = parseInt(currentDate[1]) - 1;
            let year = parseInt(currentDate[2]);
            return this.months[month] + " " + day + ", " + year;
        } else {
            let currentDate
            if (inputDate.includes('/')) {
                currentDate = new String(inputDate).split(' ')[0].split('/');
            } else if (inputDate.includes('-')) {
                currentDate = new String(inputDate).split(' ')[0].split('-');
            }


            let day;
            let month;
            let year;

            if (srcFomate == 'DD/MM/YYYY' || srcFomate == 'DD-MM-YYYY') {
                day = currentDate[0].charAt(0) != '0' ? parseInt(currentDate[0]) : '0' + parseInt(currentDate[0]);
                month = currentDate[1].charAt(0) != '0' ? parseInt(currentDate[1]) : '0' + parseInt(currentDate[1]);
                year = parseInt(currentDate[2]);
            } else if (srcFomate == 'MM/DD/YYYY' || srcFomate == 'MM-DD-YYYY') {
                day = currentDate[1].charAt(0) != '0' ? parseInt(currentDate[1]) : '0' + parseInt(currentDate[1]);
                month = currentDate[0].charAt(0) != '0' ? parseInt(currentDate[0]) : '0' + parseInt(currentDate[0]);
                year = parseInt(currentDate[2]);
            } else if (srcFomate == 'YYYY/MM/DD' || srcFomate == 'YYYY-MM-DD') {
                day = currentDate[2].charAt(0) != '0' ? parseInt(currentDate[2]) : '0' + parseInt(currentDate[2]);
                month = currentDate[1].charAt(0) != '0' ? parseInt(currentDate[1]) : '0' + parseInt(currentDate[1]);
                year = parseInt(currentDate[0]);
            } else if (srcFomate == "MMM DD, YYYY") {
                currentDate = new String(inputDate).split(' ')
                let index = this.months.indexOf(currentDate[0]) + 1
                day = currentDate[1].replace(',', '').trim().charAt(0) != '0' ? parseInt(currentDate[1]) : '0' + parseInt(currentDate[1]);
                month = new String(index).length != 1 ? index : '0' + index;
                year = parseInt(currentDate[2]);
            }



            if (designateFomate == "DD-MM-YYYY") {
                return day + "-" + month + "-" + year;
            } else if (designateFomate == "DD/MM/YYYY") {
                return day + "/" + month + "/" + year;
            } else if (designateFomate == "MM-DD-YYYY") {
                return month + "-" + day + "-" + year;
            } else if (designateFomate == "MM/DD/YYYY") {
                return month + "/" + day + "/" + year;
            } else if (designateFomate == "YYYY-MM-DD") {
                return year + "-" + month + "-" + day;
            } else if (designateFomate == "YYYY/MM/DD") {
                return year + "/" + month + "/" + day;
            } else if (designateFomate == "MMM DD, YYYY") {
                return this.months[month - 1] + " " + day + ", " + year;
            }
        }
    }

    dateConversionForYYYYMMDD(inputDate: any) {
        let currentDate = new String(inputDate).split(' ')[0].split('-');
        let day = currentDate[2].charAt(0) != '0' ? parseInt(currentDate[2]) : '0' + parseInt(currentDate[2]);
        let month = parseInt(currentDate[1]) - 1;
        let year = parseInt(currentDate[0]);
        return this.months[month] + " " + day + ", " + year;
    }

    formatAmount(number) {
        return new Intl.NumberFormat(environment.currencyFormat, { minimumFractionDigits: 2 }).format(number);
    }
    formatCarbon(number) {
        return new Intl.NumberFormat(environment.currencyFormat, { minimumFractionDigits: 1 }).format(number);
    }

    formatDate(inputDate: any) {
        let currentDate = new String(inputDate).split(' ')[0].split('-');
        let day = parseInt(currentDate[0]);
        let month = parseInt(currentDate[1]) - 1;
        let year = parseInt(currentDate[2]);
        return this.months[month] + " " + day + ", " + year;
    }

    copyTextToClipboard(text, successMsg, successCallback) {
        var textArea = document.createElement("textarea");
        textArea.style.position = 'fixed';
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.width = '2em';
        textArea.style.height = '2em';

        textArea.style.padding = "0";

        textArea.style.border = 'none';
        textArea.style.outline = 'none';
        textArea.style.boxShadow = 'none';

        textArea.style.background = 'transparent';

        textArea.value = text;

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';
            if (successCallback) successCallback(successful);
            console.log('Copying text command was ' + msg);
            this.showToastr({
                message: successMsg
            });
        } catch (err) {
            console.log('Oops, unable to copy');
        }
        document.body.removeChild(textArea);
    }

    shareInfo(content, successMsg) {
        if (this.isHybrid()) {
            this.socialSharing.share(content).then(() => {
                console.log("Info share success!");
            }).catch(() => {
                console.log("Info share failure!");
            });
        } else {
            this.copyTextToClipboard(content, successMsg, null);
        }
    }

    toastrOverlayTimeout: any;
    /**
     * 
     * @param data {
     *  message: '',
     *  title: '',
     *  type: 'success'
     * }
     */
    showToastr(data) {
        var msg = data.message;
        var title = data.title || "";
        var delay = data.delay || 5000;
        var toastrType = data.type || "success";

        this.toastrService[toastrType](msg, title, { timeOut: delay, closeButton: true })
            .onHidden
            .subscribe(() => this.toasterClickedHandler());

        var overlayEl = document.getElementById("toast-container").closest(".overlay-container");
        overlayEl['style'].display = "block";
        var _this = this;
        this.toastrOverlayTimeout = setTimeout(function () {
            _this.hideToasterOverlay();
        }, (delay));
    }

    toasterClickedHandler() {
        if (this.toastrOverlayTimeout) {
            clearTimeout(this.toastrOverlayTimeout);
            this.hideToasterOverlay();
        }
    }
    hideToasterOverlay() {
        var overlayEl = document.getElementById("toast-container").closest(".overlay-container");
        overlayEl['style'].display = "none";
    }
    pickContact(successCallback, failurCallback, targetComponent) {
        this.contacts.pickContact().then((contact) => {
            console.log("contacts:-->" + JSON.stringify(contact));
            if (successCallback) targetComponent[successCallback](contact);
        });
    }
    isFormUpdated(oldData, currentData) {
        var oldData = oldData;
        var currentData = currentData;
        if (JSON.stringify(oldData) === JSON.stringify(currentData)) {
            return true;
        }
        else {
            return false;
        }
    }

    greenifyTogglesubject = new BehaviorSubject<any>(false);

    emitGreenifyToggleData(event) {
        this.greenifyTogglesubject.next(event)
    }

    /**
     * Will store data in native storage by key pair value
     * @param key 
     * @param data 
     */
    storeData(key: any, data: any) {
        this.nativeStorage.setItem(key, data).then(
            () => console.log('Stored! ' + key),
            error => console.error('Error storing item', error)
        );
    }
    loadData(key: any) {
        return this.nativeStorage.getItem(key);
    }

    storePIN(pin) {
        let signature = btoa(pin);
        console.log(signature);
        this.storeData('signature', signature);
        this.mobileService.isPINConfigured = true;
    }

    validatePIN(pin): Promise<any> {
        return this.loadData('signature').then((res) => {
            return new Promise((resolve, reject) => {
                let signature = atob(res);
                resolve(signature == pin);
            });
        })
    }
}